<script>
import DidoDatafileCard from "./components/DatafileCard.vue";

export default {
  name: "DidoDatafileCardCe",
  components: {
    DidoDatafileCard,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoDatafileRid: { type: String, required: true },
  },
  emits: [
    "datafile-retrieved",
    "datafile-not-retrieved",
    "click-card",
    "label-selection",
    "bad-configuration",
  ],
  template: `
    <DidoDatafileCard
      :api-url="didoUrl"
      :datafile-rid="didoDatafileRid"
      @datafile-retrieved="$emit('datafile-retrieved', $event)"
      @datafile-not-retrieved="$emit('datafile-not-retrieved', $event)"
      @click-card="$emit('click-card', $event)"
      @label-selection="$emit('label-selection', $event)"
      @bad-configuration="$emit('bad-configuration')"
    />`,
};
</script>
